export default {
    meta: {
        title: '拓店宝-机会点表单页',
        url: '/chancepoint',
        urlName: '机会点' // 埋点字段，上报归属的模块
    }
};
